import { cx, styled } from "simplydo/react/styled";

import type { CardMetaProps } from "./Card.types";

const MetaEl = styled.div`
  font-size: 0.9em;
  color: rgba(0, 0, 0, 0.4);
  margin-top: 0.3em;
`;

const CardMetaComponent = (props: CardMetaProps) => {
  const { children, className, style } = props;
  return (
    <MetaEl className={cx(className)} style={style}>
      {children}
    </MetaEl>
  );
};

export const CardMeta = styled(CardMetaComponent)``;
